import { Box } from '@chakra-ui/react';
import React from 'react';

export const DataTablePlaceholder: React.FC = ({ children }) => {
  return (
    <Box
      fontSize="md"
      fontStyle="italic"
      borderRadius="6px"
      padding="1.25rem 1.5rem 1.25rem 2.5rem"
      color="gray.500"
      bgColor="white"
      border="1px solid #eaf0f6"
    >
      {children}
    </Box>
  );
};
